module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('Header', {
    staticClass: "black"
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "uinfo clearfix"
  }, [_c('div', {
    staticClass: "mask l"
  }, [_c('img', {
    attrs: {
      "src": _vm.detail.coverUrl + _vm.$resize(200, 200)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont l"
  }, [_c('div', {
    staticClass: "topbar clearfix"
  }, [_c('div', {
    staticClass: "l"
  }, [_c('span', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.detail.name))]), _vm._v(" "), (_vm.detail.isProducer == 1) ? _c('span', {
    staticClass: "auth"
  }) : _vm._e(), _vm._v(" "), (_vm.detail.gender == 1) ? _c('span', {
    staticClass: "sex blue"
  }, [_vm._v("男")]) : _vm._e(), _vm._v(" "), (_vm.detail.gender == 2) ? _c('span', {
    staticClass: "sex red"
  }, [_vm._v("女")]) : _vm._e(), _vm._v(" "), (_vm.detail.favouriteType == 1) ? _c('span', {
    staticClass: "type bgyellow"
  }, [_vm._v("演员")]) : _vm._e(), _vm._v(" "), (_vm.detail.favouriteType == 2) ? _c('span', {
    staticClass: "type bgblue"
  }, [_vm._v("KOL")]) : _vm._e(), _vm._v(" "), (_vm.detail.favouriteType == 3) ? _c('span', {
    staticClass: "type bgred"
  }, [_vm._v("配音")]) : _vm._e()]), _vm._v(" "), (_vm.isme) ? _c('div', {
    staticClass: "buttons r",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.detail.isProducer == 0) ? _c('button', {
    staticClass: "btn btn-empty",
    on: {
      "click": function($event) {
        return _vm.toAuth()
      }
    }
  }, [_vm._v("制作人认证")]) : _vm._e(), _vm._v(" "), (_vm.detail.isProducer == 1) ? _c('button', {
    staticClass: "btn bgyellow",
    on: {
      "click": function($event) {
        return _vm.toAuth()
      }
    }
  }, [_vm._v("已认证")]) : _vm._e(), _vm._v(" "), (_vm.detail.isProducer == 2) ? _c('button', {
    staticClass: "btn bgorange"
  }, [_vm._v("认证审核中")]) : _vm._e(), _vm._v(" "), (_vm.detail.isProducer == 3) ? _c('button', {
    staticClass: "btn bgred",
    on: {
      "click": function($event) {
        return _vm.toAuth()
      }
    }
  }, [_vm._v("认证失败")]) : _vm._e(), _vm._v(" "), (_vm.produceAuthMsg) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "bottom": "-35px",
      "width": "200px",
      "color": "#FF4C4C"
    }
  }, [_vm._v("*未满3个月不可以重新进行认证")]) : _vm._e()]) : _c('div', {
    staticClass: "keep"
  }, [(!_vm.detail.isKeep) ? _c('button', {
    staticClass: "btn btn-empty btn-collect r",
    on: {
      "click": _vm.onKeep
    }
  }, [_c('i'), _vm._v("收藏")]) : _vm._e(), _vm._v(" "), (_vm.detail.isKeep) ? _c('button', {
    staticClass: "btn btn-empty btn-collect r ed",
    on: {
      "click": _vm.onKeep
    }
  }, [_c('i'), _vm._v("已收藏")]) : _vm._e()])]), _vm._v(" "), (_vm.detail.favouriteType == 3) ? _c('div', {
    staticClass: "summary"
  }, [_vm._v(_vm._s(_vm.detail.summary ? _vm.detail.summary : '未填写'))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "baseinfo clearfix"
  }, [(_vm.detail.favouriteType == 1) ? _c('div', {
    staticClass: "l"
  }, [_c('span', [_vm._v("职业：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detail.modelOrActor ? _vm.detail.modelOrActor : '未填写'))])]) : _vm._e(), _vm._v(" "), (_vm.detail.favouriteType == 1) ? _c('div', {
    staticClass: "l"
  }, [_c('span', [_vm._v("类别：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detail.type ? _vm.getPalentType(_vm.detail.type) : '未填写'))])]) : _vm._e(), _vm._v(" "), (_vm.detail.favouriteType == 1 || _vm.detail.favouriteType == 2) ? _c('div', {
    staticClass: "l"
  }, [_c('span', [_vm._v("生日：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")((_vm.detail.birth ? _vm.detail.birth : '未填写'))))])]) : _vm._e(), _vm._v(" "), (_vm.detail.favouriteType == 2) ? _c('div', {
    staticClass: "l"
  }, [_c('span', [_vm._v("星座：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detail.constellation ? _vm.detail.constellation : '未填写'))])]) : _vm._e(), _vm._v(" "), (_vm.detail.favouriteType == 2) ? _c('div', {
    staticClass: "l"
  }, [_c('span', [_vm._v("所在城市：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detail.city ? _vm.detail.city : '未填写'))])]) : _vm._e(), _vm._v(" "), (_vm.detail.favouriteType == 1 || _vm.detail.favouriteType == 2) ? _c('div', {
    staticClass: "l"
  }, [_c('span', [_vm._v("身高：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detail.height ? _vm.detail.height + 'cm' : '未填写'))])]) : _vm._e(), _vm._v(" "), (_vm.detail.favouriteType == 1 || _vm.detail.favouriteType == 2) ? _c('div', {
    staticClass: "l"
  }, [_c('span', [_vm._v("体重：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detail.weight ? _vm.detail.weight + 'kg' : '未填写'))])]) : _vm._e(), _vm._v(" "), (_vm.detail.favouriteType == 1) ? _c('div', {
    staticClass: "l"
  }, [_c('span', [_vm._v("三围：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detail.bust ? (_vm.detail.bust + 'cm,' + _vm.detail.buttLine + 'cm,' + _vm.detail.waistLine + 'cm') : '未填写'))])]) : _vm._e(), _vm._v(" "), (_vm.detail.favouriteType == 2) ? _c('div', {
    staticClass: "l"
  }, [_c('span', [_vm._v("特长：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detail.skill ? _vm.detail.skill : '未填写'))])]) : _vm._e()]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "tabsbar clearfix"
  }, [_c('div', {
    staticClass: "tabs l"
  }, [(_vm.detail.favouriteType != 3) ? _c('span', {
    staticClass: "tab",
    class: {
      on: _vm.currTab == 1
    },
    on: {
      "click": function($event) {
        return _vm.onTabPanel(1)
      }
    }
  }, [_vm._v("美图")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "tab",
    class: {
      on: _vm.currTab == 2
    },
    on: {
      "click": function($event) {
        return _vm.onTabPanel(2)
      }
    }
  }, [_vm._v("视频作品")]), _vm._v(" "), (_vm.detail.favouriteType != 3) ? _c('span', {
    staticClass: "tab",
    class: {
      on: _vm.currTab == 3
    },
    on: {
      "click": function($event) {
        return _vm.onTabPanel(3)
      }
    }
  }, [_vm._v("资料")]) : _vm._e(), _vm._v(" "), (_vm.isme) ? _c('span', {
    staticClass: "tab",
    class: {
      on: _vm.currTab == 4
    },
    on: {
      "click": function($event) {
        return _vm.onTabPanel(4)
      }
    }
  }, [_vm._v("认证信息")]) : _vm._e(), _vm._v(" "), (_vm.isme && _vm.detail.isProducer == 1) ? _c('span', {
    staticClass: "tab",
    class: {
      on: _vm.currTab == 5
    },
    on: {
      "click": function($event) {
        return _vm.onTabPanel(5)
      }
    }
  }, [_vm._v("服务协议")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "opera r"
  }, [(_vm.currTab == 1 && _vm.isme) ? _c('div', {
    staticClass: "btns"
  }, [(!_vm.imglist.length && (_vm.detail.photoStatus == 0 || _vm.detail.photoStatus == 2)) ? _c('button', {
    staticClass: "btn btn-default btn-w100",
    on: {
      "click": function($event) {
        return _vm.onEditPhoto()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon1"
  }), _vm._v("上传美图")]) : _vm._e(), _vm._v(" "), (_vm.imglist.length && (_vm.detail.photoStatus == 0 || _vm.detail.photoStatus == 2)) ? _c('button', {
    staticClass: "btn btn-default btn-w100",
    on: {
      "click": function($event) {
        return _vm.onEditPhoto()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon5"
  }), _vm._v("编辑美图")]) : _vm._e(), _vm._v(" "), (_vm.detail.photoStatus == 1) ? _c('button', {
    staticClass: "btn btn-default bggreen",
    on: {
      "click": function($event) {
        return _vm.onEditPhoto()
      }
    }
  }, [_vm._v("审核中")]) : _vm._e(), _vm._v(" "), (_vm.detail.photoStatus == 3) ? _c('button', {
    staticClass: "btn btn-default bgred",
    on: {
      "click": function($event) {
        return _vm.onEditPhoto()
      }
    }
  }, [_vm._v("审核失败")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.currTab == 2) ? _c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.value),
      expression: "search.value"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.search.text,
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.search.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "value", $event.target.value)
      }
    }
  }), _c('a', {
    on: {
      "click": _vm.onSearch
    }
  })]), _vm._v(" "), (_vm.isme) ? _c('button', {
    staticClass: "btn btn-default btn-w100",
    on: {
      "click": function($event) {
        return _vm.toPublish()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon2"
  }), _vm._v("发布作品")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.currTab == 3 && _vm.isme) ? _c('div', {
    staticClass: "btns"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editData.state),
      expression: "!editData.state"
    }],
    staticClass: "btn btn-default btn-w100",
    on: {
      "click": function($event) {
        return _vm.onEditData()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon5"
  }), _vm._v("修改资料")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editData.state),
      expression: "editData.state"
    }],
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.onSaveData()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editData.state),
      expression: "editData.state"
    }],
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.onEditData()
      }
    }
  }, [_vm._v("取消")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panels"
  }, [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.imglist.length && _vm.currTab == 1),
      expression: "!imglist.length && currTab == 1"
    }],
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/544.png")
    }
  }), _vm._v(" "), (!_vm.isme) ? _c('div', [_c('p', {
    staticClass: "etitle"
  }, [_vm._v("这个人太低调了，还没有上传美图")]), _vm._v(" "), _c('p', [_vm._v("去看看其他内容吧～")])]) : _vm._e(), _vm._v(" "), (_vm.isme) ? _c('div', [_c('p', {
    staticClass: "etitle"
  }, [_vm._v("您还没有上传美图哦～")]), _vm._v(" "), _c('p', [_vm._v("发布靓照向大家展示自己风采吧")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.defaultPanel.panel2),
      expression: "defaultPanel.panel2"
    }],
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/546.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("没有搜索到相关内容，换个关键词试试")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.defaultPanel.panel1 && _vm.currTab == 2 && !_vm.defaultPanel.panel2),
      expression: "defaultPanel.panel1 && currTab == 2 && !defaultPanel.panel2"
    }],
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/547.png")
    }
  }), _vm._v(" "), (!_vm.isme) ? _c('div', [_c('p', {
    staticClass: "etitle"
  }, [_vm._v("这个人太低调了，还没有发布作品")]), _vm._v(" "), _c('p', [_vm._v("去看看其他内容吧～")])]) : _vm._e(), _vm._v(" "), (_vm.isme) ? _c('div', [_c('p', {
    staticClass: "etitle"
  }, [_vm._v("您还没有上传作品哦～")]), _vm._v(" "), _c('p', [_vm._v("你若您有作品可用于展示，可发布作品，提升接单率")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currTab == 1),
      expression: "currTab == 1"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "photo"
  }, _vm._l((_vm.imglist), function(item) {
    return _c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item + _vm.$resize(277, 480)
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currTab == 2 && (_vm.caselist.length || Object.keys(_vm.topcase).length)),
      expression: "currTab == 2 && (caselist.length || Object.keys(topcase).length)"
    }],
    staticClass: "panel"
  }, [(Object.keys(_vm.topcase).length) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.search.value),
      expression: "!search.value"
    }],
    staticClass: "topping clearfix"
  }, [_c('div', {
    staticClass: "img l"
  }, [_c('a', {
    attrs: {
      "href": 'caseDe.html?id=' + _vm.topcase.id
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.topcase.coverUrl + _vm.$resize(790, 474)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "length"
  }, [_vm._v(_vm._s(_vm.topcase.videoLength))])]), _vm._v(" "), _c('div', {
    staticClass: "info-box r"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "h2"
  }, [_vm._v(_vm._s(_vm.topcase.title))]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [(_vm.isme) ? _c('span', {
    staticClass: "ident"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("置顶作品")]) : _vm._e(), _vm._v("发布时间：" + _vm._s(_vm._f("formatDate")(_vm.topcase.addTime)))]), _vm._v(" "), _c('ul', {
    staticClass: "tag clearfix"
  }, _vm._l((_vm.topcase.typeStr), function(ys) {
    return _c('li', [_c('span', [_vm._v(_vm._s(ys))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_vm._v(_vm._s(_vm.topcase.description))])]), _vm._v(" "), (_vm.isme && _vm.topcase.checkStatus != 0) ? _c('div', {
    staticClass: "opera"
  }, [_c('a', {
    staticClass: "edit",
    attrs: {
      "href": 'publication.html?edit=' + _vm.topcase.id
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('a', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.onDelWork(_vm.topcase)
      }
    }
  }, [_vm._v("删除")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list clearfix"
  }, _vm._l((_vm.caselist), function(item) {
    return _c('div', {
      staticClass: "case l"
    }, [_c('div', {
      staticClass: "imgbox"
    }, [_c('a', {
      attrs: {
        "href": 'caseDe.html?id=' + item.id,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.coverUrl + _vm.$resize(380, 214)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "length"
    }, [_vm._v(_vm._s(item.videoLength))])]), _vm._v(" "), (item.checkStatus == 1) ? _c('div', {
      staticClass: "bg summary"
    }, [_c('p', [_vm._v(_vm._s(item.description))])]) : _vm._e()]), _vm._v(" "), (item.checkStatus != 1) ? _c('div', {
      staticClass: "bg state"
    }, [(item.checkStatus == 0) ? _c('p', {
      staticClass: "audit"
    }, [_c('i', {
      staticClass: "icon"
    }), _vm._v("审核中")]) : _vm._e(), _vm._v(" "), (item.checkStatus == 2) ? _c('p', {
      staticClass: "fail"
    }, [_c('i', {
      staticClass: "icon"
    }), _vm._v("审核失败")]) : _vm._e(), _vm._v(" "), (item.checkStatus == 2) ? _c('p', {
      staticStyle: {
        "padding": "0 35px",
        "margin-top": "15px",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.checkMsg))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "info-box"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "h3"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('ul', {
      staticClass: "tag clearfix"
    }, _vm._l((item.typeStr), function(ys, index) {
      return (index < 3) ? _c('li', {
        staticClass: "l"
      }, [_c('span', [_vm._v(_vm._s(ys))])]) : _vm._e()
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDate")(item.addTime)))]), _vm._v(" "), (_vm.isme && item.checkStatus != 0) ? _c('div', {
      staticClass: "opera r"
    }, [(item.checkStatus == 1) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.onSetTop(item.id)
        }
      }
    }, [_vm._v("置顶")]) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'publication.html?edit=' + item.id
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('a', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.onDelWork(item)
        }
      }
    }, [_vm._v("删除")])]) : _vm._e()])])])
  }), 0), _vm._v(" "), (_vm.totalPage / _vm.pageSize > 1) ? _c('div', {
    staticClass: "pages"
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalPage,
      "page-size": _vm.pageSize,
      "current": _vm.currPage
    },
    on: {
      "on-change": _vm.onPageChange
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currTab == 3),
      expression: "currTab == 3"
    }],
    staticClass: "panel"
  }, [(_vm.detail.favouriteType == 1) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editData.state),
      expression: "!editData.state"
    }],
    staticClass: "data clearfix"
  }, [_c('div', {
    staticClass: "l left"
  }, [_c('div', {
    staticClass: "ain"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_vm._v(_vm._s(_vm.detail.summary ? _vm.detail.summary : '未填写'))])]), _vm._v(" "), _c('div', {
    staticClass: "base"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "cont clearfix"
  }, [_c('div', {
    staticClass: "div50 l"
  }, [_c('div', [_c('span', [_vm._v("身高")]), _vm._v(_vm._s(_vm.detail.height ? _vm.detail.height + 'cm' : '未填写'))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("胸围")]), _vm._v(_vm._s(_vm.detail.bust ? _vm.detail.bust + 'cm' : '未填写'))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("腰围")]), _vm._v(_vm._s(_vm.detail.waistLine ? _vm.detail.waistLine + 'cm' : '未填写'))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("臀围")]), _vm._v(_vm._s(_vm.detail.buttLine ? _vm.detail.buttLine + 'cm' : '未填写'))])]), _vm._v(" "), _c('div', {
    staticClass: "div50 r"
  }, [_c('div', [_c('span', [_vm._v("体重")]), _vm._v(_vm._s(_vm.detail.weight ? _vm.detail.weight + 'kg' : '未填写'))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("生日")]), _vm._v(_vm._s(_vm._f("formatDate")((_vm.detail.birth ? _vm.detail.birth : '未填写'))))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("星座")]), _vm._v(_vm._s(_vm.detail.constellation ? _vm.detail.constellation : '未填写'))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("特长")]), _vm._v(_vm._s(_vm.detail.skill ? _vm.detail.skill : '未填写'))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "r right"
  }, [_c('div', {
    staticClass: "works"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, _vm._l((_vm.worklist), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "wt"
    }, [_vm._v("《" + _vm._s(item[0]) + "》")]), _vm._v(" "), _c('div', {
      staticClass: "wb clearfix"
    }, [_c('div', [_c('span', [_vm._v("饰演：")]), _vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("导演：")]), _vm._v(_vm._s(item[2]))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("作品类型：")]), _vm._v(_vm._s(item[3]))])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editData.state),
      expression: "editData.state"
    }],
    staticClass: "data clearfix"
  }, [_c('div', {
    staticClass: "l left"
  }, [_c('div', {
    staticClass: "ain"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_vm._v(_vm._s(_vm.detail.summary ? _vm.detail.summary : '未填写'))])]), _vm._v(" "), _c('div', {
    staticClass: "base"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "cont clearfix"
  }, [_c('div', {
    staticClass: "l"
  }, [_c('div', [_c('span', [_vm._v("身高:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editData.form.height),
      expression: "editData.form.height"
    }],
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.editData.form.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editData.form, "height", $event.target.value)
      }
    }
  }), _vm._v(" cm\n                      ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("胸围:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editData.form.bust),
      expression: "editData.form.bust"
    }],
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.editData.form.bust)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editData.form, "bust", $event.target.value)
      }
    }
  }), _vm._v(" cm\n                      ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("腰围:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editData.form.waistLine),
      expression: "editData.form.waistLine"
    }],
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.editData.form.waistLine)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editData.form, "waistLine", $event.target.value)
      }
    }
  }), _vm._v(" cm\n                      ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("臀围:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editData.form.buttLine),
      expression: "editData.form.buttLine"
    }],
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.editData.form.buttLine)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editData.form, "buttLine", $event.target.value)
      }
    }
  }), _vm._v(" cm\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "r"
  }, [_c('div', [_c('span', [_vm._v("体重:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editData.form.weight),
      expression: "editData.form.weight"
    }],
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.editData.form.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editData.form, "weight", $event.target.value)
      }
    }
  }), _vm._v(" kg\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "input180"
  }, [_c('span', [_vm._v("生日:")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editData.form.birth),
      callback: function($$v) {
        _vm.$set(_vm.editData.form, "birth", $$v)
      },
      expression: "editData.form.birth"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input180"
  }, [_c('span', [_vm._v("星座:")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "180px"
    },
    model: {
      value: (_vm.editData.form.constellation),
      callback: function($$v) {
        _vm.$set(_vm.editData.form, "constellation", $$v)
      },
      expression: "editData.form.constellation"
    }
  }, _vm._l((_vm.starlist), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "input180"
  }, [_c('span', [_vm._v("特长:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editData.form.skill),
      expression: "editData.form.skill"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.editData.form.skill)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editData.form, "skill", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "r right"
  }, [_c('div', {
    staticClass: "works"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_vm._l((_vm.worklist), function(item, index) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "wt input100"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item[0]),
        expression: "item[0]"
      }],
      attrs: {
        "type": "text",
        "maxlength": "30"
      },
      domProps: {
        "value": (item[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, 0, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wb clearfix"
    }, [_c('div', {
      staticClass: "inputH25"
    }, [_c('span', [_vm._v("饰演：")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item[1]),
        expression: "item[1]"
      }],
      attrs: {
        "type": "text",
        "maxlength": "6"
      },
      domProps: {
        "value": (item[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, 1, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "inputH25"
    }, [_c('span', [_vm._v("导演：")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item[2]),
        expression: "item[2]"
      }],
      attrs: {
        "type": "text",
        "maxlength": "6"
      },
      domProps: {
        "value": (item[2])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, 2, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "inputH25"
    }, [_c('span', [_vm._v("作品类型：")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item[3]),
        expression: "item[3]"
      }],
      attrs: {
        "type": "text",
        "maxlength": "6"
      },
      domProps: {
        "value": (item[3])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, 3, $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "del",
      on: {
        "click": function($event) {
          return _vm.onDelWorksInfo(index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editData.stateAdd),
      expression: "editData.stateAdd"
    }],
    staticClass: "item"
  }, [_c('div', {
    staticClass: "wt input100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editData.work[0]),
      expression: "editData.work[0]"
    }],
    attrs: {
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.editData.work[0])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editData.work, 0, $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wb clearfix"
  }, [_c('div', {
    staticClass: "inputH25"
  }, [_c('span', [_vm._v("饰演：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editData.work[1]),
      expression: "editData.work[1]"
    }],
    attrs: {
      "type": "text",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.editData.work[1])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editData.work, 1, $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inputH25"
  }, [_c('span', [_vm._v("导演：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editData.work[2]),
      expression: "editData.work[2]"
    }],
    attrs: {
      "type": "text",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.editData.work[2])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editData.work, 2, $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inputH25"
  }, [_c('span', [_vm._v("作品类型：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editData.work[3]),
      expression: "editData.work[3]"
    }],
    attrs: {
      "type": "text",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.editData.work[3])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editData.work, 3, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "del",
    on: {
      "click": _vm.onDelAddWorksInfo
    }
  })]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn btn-empty empty-blue",
    staticStyle: {
      "width": "160px"
    },
    on: {
      "click": _vm.onAddWorkInfo
    }
  }, [_c('i', {
    staticClass: "icon icon3"
  }), _vm._v("添加作品")])])], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.detail.favouriteType == 2) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editData.state),
      expression: "!editData.state"
    }],
    staticClass: "data clearfix"
  }, [_c('div', {
    staticClass: "l left"
  }, [_c('div', {
    staticClass: "ain"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_vm._v(_vm._s(_vm.detail.summary ? _vm.detail.summary : '未填写'))])])]), _vm._v(" "), _c('div', {
    staticClass: "r right"
  }, [_c('div', {
    staticClass: "base"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "cont clearfix"
  }, [_c('div', [_c('div', [_c('span', [_vm._v("身高")]), _vm._v(_vm._s(_vm.detail.height ? _vm.detail.height + 'cm' : '未填写'))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("体重")]), _vm._v(_vm._s(_vm.detail.weight ? _vm.detail.weight + 'kg' : '未填写'))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("生日")]), _vm._v(_vm._s(_vm._f("formatDate")((_vm.detail.birth ? _vm.detail.birth : '未填写'))))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("星座")]), _vm._v(_vm._s(_vm.detail.constellation ? _vm.detail.constellation : '未填写'))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("特长")]), _vm._v(_vm._s(_vm.detail.skill ? _vm.detail.skill : '未填写'))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editData.state),
      expression: "editData.state"
    }],
    staticClass: "data clearfix"
  }, [_c('div', {
    staticClass: "l left"
  }, [_c('div', {
    staticClass: "ain"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_vm._v(_vm._s(_vm.detail.summary ? _vm.detail.summary : '未填写'))])])]), _vm._v(" "), _c('div', {
    staticClass: "r right"
  }, [_c('div', {
    staticClass: "base"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "cont clearfix"
  }, [_c('div', [_c('div', [_c('span', [_vm._v("身高:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editData.form.height),
      expression: "editData.form.height"
    }],
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.editData.form.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editData.form, "height", $event.target.value)
      }
    }
  }), _vm._v(" cm\n                      ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("体重:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editData.form.weight),
      expression: "editData.form.weight"
    }],
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.editData.form.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editData.form, "weight", $event.target.value)
      }
    }
  }), _vm._v(" kg\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "input180"
  }, [_c('span', [_vm._v("生日:")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editData.form.birth),
      callback: function($$v) {
        _vm.$set(_vm.editData.form, "birth", $$v)
      },
      expression: "editData.form.birth"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input180"
  }, [_c('span', [_vm._v("星座:")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "180px"
    },
    model: {
      value: (_vm.editData.form.constellation),
      callback: function($$v) {
        _vm.$set(_vm.editData.form, "constellation", $$v)
      },
      expression: "editData.form.constellation"
    }
  }, _vm._l((_vm.starlist), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "input180"
  }, [_c('span', [_vm._v("特长:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editData.form.skill),
      expression: "editData.form.skill"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.editData.form.skill)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editData.form, "skill", $event.target.value)
      }
    }
  })])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currTab == 4),
      expression: "currTab == 4"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "pane-accinfo"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('span', [_vm._v("制作人资质认证")]), _vm._v(" "), (_vm.isme) ? _c('div', {
    staticClass: "buttons r",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.detail.isProducer == 0) ? _c('button', {
    staticClass: "btn btn-empty",
    on: {
      "click": function($event) {
        return _vm.toAuth()
      }
    }
  }, [_vm._v("制作人认证")]) : _vm._e(), _vm._v(" "), (_vm.detail.isProducer == 1) ? _c('button', {
    staticClass: "btn bgyellow",
    on: {
      "click": function($event) {
        return _vm.toAuth()
      }
    }
  }, [_vm._v("已认证")]) : _vm._e(), _vm._v(" "), (_vm.detail.isProducer == 2) ? _c('button', {
    staticClass: "btn bgorange",
    on: {
      "click": function($event) {
        return _vm.toAuth()
      }
    }
  }, [_vm._v("认证审核中")]) : _vm._e(), _vm._v(" "), (_vm.detail.isProducer == 3) ? _c('button', {
    staticClass: "btn bgred",
    on: {
      "click": function($event) {
        return _vm.toAuth()
      }
    }
  }, [_vm._v("认证失败")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cont clearfix"
  }, [_c('div', {
    staticClass: "l"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("认证类型：")]), _vm._v(" "), (_vm.authInfo.favouriteType == 1) ? _c('span', [_vm._v("演员")]) : _vm._e(), _vm._v(" "), (_vm.authInfo.favouriteType == 2) ? _c('span', [_vm._v("KOL")]) : _vm._e(), _vm._v(" "), (_vm.authInfo.favouriteType == 3) ? _c('span', [_vm._v("配音")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("真实姓名：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.authInfo.producerName))])]), _vm._v(" "), _c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("性别：")]), _vm._v(" "), (_vm.authInfo.gender == 0) ? _c('span', [_vm._v("其他")]) : _vm._e(), _vm._v(" "), (_vm.authInfo.gender == 1) ? _c('span', [_vm._v("男")]) : _vm._e(), _vm._v(" "), (_vm.authInfo.gender == 2) ? _c('span', [_vm._v("女")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("所在城市：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.authInfo.city))])]), _vm._v(" "), _c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("从业年份：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.authInfo.joinDate) + "年")])])]), _vm._v(" "), _c('div', {
    staticClass: "r"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("报价：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.authInfo.fee) + "/天")])]), _vm._v(" "), _c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("简介：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.authInfo.summary))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currTab == 5),
      expression: "currTab == 5"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "protocol"
  }, [_vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "opera"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detail.gmSignStatus == 0),
      expression: "detail.gmSignStatus == 0"
    }],
    staticClass: "btn btn-empty"
  }, [_vm._v("未签署")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detail.gmSignStatus == 1),
      expression: "detail.gmSignStatus == 1"
    }],
    staticClass: "btn"
  }, [_vm._v("已签署")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detail.gmSignStatus == 2),
      expression: "detail.gmSignStatus == 2"
    }],
    staticClass: "btn red"
  }, [_vm._v("已过期")])])])])])])]), _vm._v(" "), _c('Modal', {
    staticClass: "modal",
    attrs: {
      "title": "提示",
      "width": "480",
      "footer-hide": ""
    },
    model: {
      value: (_vm.ModalDelete.state),
      callback: function($$v) {
        _vm.$set(_vm.ModalDelete, "state", $$v)
      },
      expression: "ModalDelete.state"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "30px",
      "font-size": "18px",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "38px"
    }
  }, [_vm._v("确定删除当前作品吗？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('Button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.onModalDeleteBtn()
      }
    }
  }, [_vm._v("确定")])], 1)])]), _vm._v(" "), _c('Modal', {
    staticClass: "modal photo",
    attrs: {
      "title": "编辑美图",
      "width": "920",
      "footer-hide": ""
    },
    model: {
      value: (_vm.ModalPhoto.state),
      callback: function($$v) {
        _vm.$set(_vm.ModalPhoto, "state", $$v)
      },
      expression: "ModalPhoto.state"
    }
  }, [_c('div', {
    staticClass: "cont clearfix"
  }, [_vm._l((_vm.ModalPhoto.imgs), function(item, index) {
    return _c('div', {
      staticClass: "imgs l"
    }, [_c('div', {
      staticClass: "btn-file border"
    }, [_c('img', {
      attrs: {
        "src": item + _vm.$resize(150, 266)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "hover"
    }, [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.onReplacePhoto(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon icon4"
    }), _vm._v("替换")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-empty",
      staticStyle: {
        "background": "transparent"
      },
      on: {
        "click": function($event) {
          return _vm.onDeletePhoto(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon icon6"
    }), _vm._v("删除")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "imgs l"
  }, [_c('div', {
    staticClass: "btn-file",
    attrs: {
      "id": "js-addimg"
    }
  }, [_c('div', {
    staticClass: "default text"
  }, [_c('i', {
    staticClass: "icon1"
  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("图片")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img hide"
  }, [_c('button', {
    attrs: {
      "id": "js-repimg"
    }
  }, [_vm._v("替换")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('Button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmitPhoto()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('Button', {
    staticClass: "btn btn-empty",
    on: {
      "click": function($event) {
        return _vm.onEditPhoto()
      }
    }
  }, [_vm._v("取消")])], 1)]), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera"
  }, [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "width": "116px"
    },
    attrs: {
      "href": "publish.html"
    }
  }, [_vm._v("邀请制片")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("个人介绍")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("作品信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("个人介绍")]), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v("如需修改，请前往认证信息模块")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("作品信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("个人介绍")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("个人介绍")]), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v("如需修改，请前往认证信息模块")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_vm._v("在平台接单需签署相关服务协议，请扫描下方二维码前往签署，"), _c('br'), _vm._v("若您已签署，也可通过下方二维码进行查询。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrimg"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/qr3.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b224571e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/talentActor/App.vue
// module id = 1303
// module chunks = 14